import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Btn, Icon, Pill, StoreBtn } from "../../shared/ui";
import { GOALS, reachGoal } from "../../shared/lib/metrika";
import { usePublicSettings } from "../../shared/lib/usePublicSettings";
import { clamp, prefersReducedMotion, useScrollLoop } from "../../shared/motion";
import wmUrl from "../../assets/brand/n-white.svg";
import "./cta.css";

// «Yuklab olish» CTA (prototype 332–353, landing-v4.js 205–209). Scale-in reveal is CSS (`data-r`);
// the watermark drifts and turns with the card's scroll progress via a ref write (no state).
// Section id is `download` (D2) — the mobile dock watches `#download .cta`.
const DownloadCta = () => {
  const { t } = useTranslation();
  const settings = usePublicSettings();
  const ctaRef = useRef<HTMLDivElement>(null);
  const wmRef = useRef<HTMLImageElement>(null);

  useScrollLoop(() => {
    const cta = ctaRef.current;
    const wm = wmRef.current;
    if (!cta || !wm || prefersReducedMotion()) return;
    const r = cta.getBoundingClientRect();
    // Off-screen: nothing to compute.
    if (r.bottom <= 0 || r.top >= window.innerHeight) return;
    const cp = clamp(1 - (r.top + r.height) / (window.innerHeight + r.height), 0, 1);
    wm.style.transform = `translateY(${((0.5 - cp) * 90).toFixed(1)}px) rotate(${((cp - 0.5) * 24).toFixed(2)}deg)`;
  });

  return (
    <section className="sec" id="download">
      <div className="wrap">
        <div className="cta" id="cta" data-r="scale" ref={ctaRef}>
          <img className="wm" src={wmUrl} alt="" ref={wmRef} />
          <div className="cta-c">
            <Pill tone="on-brand">{t("cta.eyebrow")}</Pill>
            <h2 className="h2">{t("cta.title")}</h2>
            <p>{t("cta.subtitle")}</p>
          </div>
          <div className="cta-btns">
            <StoreBtn store="apple" tone="white" />
            <StoreBtn store="play" tone="white" />
            <Btn
              as="a"
              variant="onbrand"
              href={settings.supportTelegramLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => reachGoal(GOALS.telegram)}
            >
              <Icon name="g-tg" className="glyph" />
              {t("cta.telegram_btn")}
            </Btn>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadCta;
